import React, { useState, useEffect } from 'react';
import './Header.css';
import { useAuth } from "../AuthContext";
import Logo from '../../assets/images/logo.png';
import { useNavigate } from 'react-router-dom';

const Header = () => {
    const [isMobile, setIsMobile] = useState(false);
    const { logout } = useAuth();
    const navigate = useNavigate();

    const menuItems = [
        { label: 'Acasă', route: '/dashboard' },
        { label: 'Bugetare', route: '/budgeting' },
        { label: 'Calendar', route: '/calendar' },
        { label: 'Angajați', route: '/employees' },
        { label: 'Istoric', route: '/history' }
    ];

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleNavigate = (route) => {
        navigate(route);
    };

    const handleLogout = () => {
        logout();
    };

    return (
        <div className="admin-header">
            <div className="header-content">
                <div className="logo-container">
                    <img
                        src={Logo}
                        alt="Logo"
                        className="logo"
                    />
                </div>

                <span className="title">Panou de administrare</span>
            </div>

            {isMobile ? (
                <div className="dropdown-menu">
                    <div className="menu-grid">
                        {menuItems.slice(0, 3).map((item, index) => (
                            <button
                                key={index}
                                onClick={() => handleNavigate(item.route)}
                                className="menu-button brown-button"
                                type="button"
                            >
                                {item.label}
                            </button>
                        ))}

                        <button
                            onClick={handleLogout}
                            className="menu-button blue-button"
                            type="button"
                        >
                            Deconectare
                        </button>

                        {menuItems.slice(3).map((item, index) => (
                            <button
                                key={index}
                                onClick={() => handleNavigate(item.route)}
                                className="menu-button brown-button"
                                type="button"
                            >
                                {item.label}
                            </button>
                        ))}
                    </div>
                </div>
            ) : (
                <div className="horizontal-menu">
                    {menuItems.map((item, index) => (
                        <button
                            key={index}
                            onClick={() => handleNavigate(item.route)}
                            className="menu-button brown-button"
                            type="button"
                        >
                            {item.label}
                        </button>
                    ))}
                    <button
                        onClick={handleLogout}
                        className="menu-button blue-button"
                        type="button"
                    >
                        Deconectare
                    </button>
                </div>
            )}
        </div>
    );
};

export default Header;
